import React, { useEffect } from 'react';
import './TermsNconditions.css';

function TermsNconditions() {

    useEffect(()=> window.scrollTo(0, 0), []);

  return (
    <div className='container my-5'>
        <h2 className="body-font-bold mb-4 fs-3">Terms & Conditions</h2>
        <p className="mb-4">
            Welcome to <span className="body-font-medium">PENTADECO</span>. These Terms and Conditions govern your use of our website, <a href="https://pentadeco.in" target='_blank' className="nav-link d-inline text-primary">www.pentadeco.in</a>, and the purchase of any products from our online store. By accessing or using our website, you agree to comply with and be bound by these Terms and Conditions.
        </p>

        <div className="content">
            <ol className='m-0'>
                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">General Information</p>
                    <ol className='m-0' type='I'>
                        <li>
                            <p className="text-muted"><span className='body-font-medium text-black'>About Us:</span> PENTADECO is an Indian e-commerce platform offering home décor, kitchen décor, and personal accessories.</p>
                        </li>
                        <li>
                            <p className="text-muted"><span className='body-font-medium text-black'>Acceptance:</span> These Terms govern all aspects of your relationship with the Website, including browsing, purchasing, payments, shipping, returns, and customer service.</p>
                        </li>
                    </ol>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Eligibility to Use</p>
                    <p className="text-muted">You must be at least 18 years old or have the involvement of a parent/guardian to make purchases. By using this site, you confirm you can legally enter into a binding contract under the Indian Contract Act, 1872.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Account Responsibilities</p>
                    <ol className='m-0' type='I'>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Account Creation:</span> You may need to create an account to purchase. Keep login details secure.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Accuracy:</span> You must provide true and updated information.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Responsibility:</span> All activities done under your account are your responsibility.</p></li>
                    </ol>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Products & Services</p>
                    <ol className='m-0' type='I'>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Accuracy:</span> We strive to provide correct descriptions, images, and prices. Minor variations may occur due to photography or screen resolution.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Availability:</span> Products are subject to stock. Orders may be cancelled if unavailable.</p></li>
                    </ol>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Orders & Payment</p>
                    <ol className='m-0' type='I'>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Confirmation:</span> Orders are confirmed only after receiving an order confirmation email/SMS.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Payment Methods:</span> We accept UPI, Net Banking, Cards, Wallets, and COD (select areas).</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Currency:</span> All transactions are in INR.</p></li>
                    </ol>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Shipping & Delivery</p>
                    <ol className='m-0' type='I'>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Timeline:</span> Orders typically deliver within 3–7 working days.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Courier Partner:</span> Once dispatched, delivery is handled by our courier partner.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Tracking:</span> Details are shared post-dispatch.</p></li>
                    </ol>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Returns & Refunds</p>
                    <ol className='m-0' type='I'>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Return:</span> Returns are accepted within 7 days for defective, damaged, or incorrect items.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Refunds:</span> Processed within 7–10 working days to original payment method.</p></li>
                        <li><p className="text-muted"><span className='body-font-medium text-black'>Exclusions:</span> Personalized products, clearance items, or misuse-related damage not eligible.</p></li>
                    </ol>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Intellectual Property</p>
                    <p className="text-muted">All content (text, logos, images, designs, product info) on this site is owned by PENTADECO. You cannot copy, modify, or use it without written consent.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">User Restrictions</p>
                    <p className="text-muted">You agree not to: misuse this Website, upload viruses, hack our systems, or resell products without permission.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Limitation of Liability</p>
                    <p className="text-muted">Our liability is limited to the value of your purchased product. We are not responsible for indirect, incidental, or consequential damages.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Termination</p>
                    <p className="text-muted">We reserve the right to suspend or terminate accounts for violations of these Terms.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Governing Law</p>
                    <p className="text-muted">These Terms are governed by the laws of India. All disputes fall under the jurisdiction of New Delhi courts.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Changes to Terms</p>
                    <p className="text-muted">We may update these Terms at any time. Continued use means acceptance of the updated Terms.</p>
                </li>

                <li className='mb-4'>
                    <p className="fs-5 body-font-medium">Contact Information</p>
                    <p className="text-muted">For any questions or support, contact us:</p>
                    <p className="mb-0">PENTADECO Customer Service</p>
                    <p className="mb-0">Email: <a href="mailto:pentadeco@gmail.com" className="nav-link d-inline text-primary">pentadeco@gmail.com</a></p>
                    <p className="mb-0">WhatsApp: <a href="tel:+917738494171" className="nav-link d-inline text-primary">+91 7738494171</a>, <a href="tel:+918433551012" className="nav-link d-inline text-primary">+91 8433551012</a>, <a href="tel:+919273158535" className="nav-link d-inline text-primary">+91 9273158535</a></p>
                </li>
            </ol>
        </div>
    </div>
  )
}

export default TermsNconditions;
